<div class="list-container">
    <div class="list-content">
        <div class="list-details">
            <!-- <h4 class="list-details-title">Document Management</h4> -->
            <div class="folder-block">
                <div class="folder-header">
                    <div class="folder-path">
                        <i (click)="folderHome()" class="bi bi-house-door-fill"></i>
                        <p ><span *ngFor="let path of folderPath;let i = index" (click)="folderPathClick(path.id)"> <i class="{{path.icon}}"></i>{{path.name}} <i class="bi bi-caret-right-fill"></i></span> </p>
                    </div>
                    <div class="add-new">
                        <!-- <button class="add-button" *ngIf="copiedData.length != 0">
                            <i class="bi bi-arrow-down-circle"></i> Paste
                        </button>
                        <button class="add-button" *ngIf="moveData.length != 0">
                            <i class="bi bi-arrows-move"></i> Move here
                        </button> -->
                        <button class="add-button" (click)="createButtonClicked()" data-toggle="modal" data-target="#createModal">
                            <i class="bi bi-folder"></i> {{ 'generic.create' | translate }}
                        </button>
                        <button class="add-button" data-toggle="modal" data-target="#createModalFile">
                            <div hidden="true">
                                <label class="image-upload-container btn btn-bwm">
                                    <!-- <span>Select Image</span> -->
                                    <input #imageInput type="file" id="add-file-btn" accept="*" hidden="true" (change)="onChange($event)" multiple>
                                </label>
                            </div>
                            <i class="bi bi-file-earmark-text"></i> {{ 'generic.file' | translate }}
                        </button>
                    </div>
                </div>
                <div class="folder-main">
                    <p-splitter 
                        [panelSizes]="[15, 85]" 
                        [style]="{ height: '500px',width: '100%' }" 
                        styleClass="mb-5"
                        (onResizeStart)="onResizeStart($event)"
                        (onResizeEnd)="onResizeEnd($event)"
                        >
                        
                        <ng-template pTemplate>
                            <div class="col flex align-items-center justify-content-center">
                                <div class="folder-menus">
                                    <div class="menus" *ngFor="let list of data">
                                    <div class="folder-name" (contextmenu)="onLeftClick($event,list)">
                                        <i *ngIf="list.isOpen" (click)="toggleFolder(list)" class="bi bi-folder-check"></i>
                                        <i *ngIf="!list.isOpen"[class]="list.icon" (click)="toggleFolder(list)"></i><p class="name" (click)="openFolder(list)">{{ list.label }}</p>
                                    </div>
                                
                                    <div class="sub-folder" *ngIf="list.isOpen">
                                        <ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: list.children }"></ng-container>
                                    </div>
                                    </div>
                                
                                    <ng-template #recursiveList let-children>
                                    <div class="sub-folder-name" *ngFor="let subFolder of children">
                                        <div class="folder-name" (contextmenu)="onLeftClick($event,subFolder)">
                                            <div class="border-line">
                                                <!-- <p class="line1"></p> -->
                                                <p class="line"></p>
                                            </div>
                                        <i *ngIf="!subFolder.isOpen" [class]="subFolder.icon" (click)="toggleFolder(subFolder)"></i>
                                        
                                        <i *ngIf="subFolder.isOpen" (click)="toggleFolder(subFolder)" class="bi bi-folder-check"></i>
                                        <p class="name" (click)="openFolder(subFolder)">{{ subFolder.label }}</p>
                                        </div>
                                
                                        <div class="sub-folder1" *ngIf="subFolder.isOpen && subFolder.children && subFolder.children.length">
                                        <ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: subFolder.children }"></ng-container>
                                        </div>
                                    </div>
                                    </ng-template>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template pTemplate>
                            <div class="col flex align-items-center justify-content-center" style="width: 100%;">
                                <div class="folder-structure" (contextmenu)="onOpenClick($event)">
                                        
                                    <div class="folder-structure-right">
                                        <div class="folder-label-header">
                                            <table class="table table-striped">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 50%;"> {{ 'client-docs-info.folderName' | translate }}</th>
                                                        <th style="width: 15%;padding-left: 0;">{{ 'client-docs-info.fileType' | translate }}</th>
                                                        <th style="width: 20%;padding-left: 0;">{{ 'client-docs-info.createdDate' | translate }}</th>
                                                        <th style="width: 15%;padding-left: 0;">{{ 'client-docs-info.createdBy' | translate }}</th>
                                                    </tr>
                                                </thead>
                                            </table>
                                        </div>
                                        <div>
                                            
                                            <!-- <div class="folder-list" *ngFor="let list of clientDocsList;let i = index">
                                                <div class="list-block" *ngFor="let keyValues of list.keyValues;let j = index">
                                                    <div class="folder" (contextmenu)="onRightClick($event,{fileType: list.keyValues[0].fileType,id: list.keyValues[0].id,clientDocsId :list.clientDocsId,name: list.keyValues[0].name})" (click)="getFolderHierarchyByParentFolderId(list.keyValues[0].id,list.clientDocsId)">
                                                        <p class="folder-label-name"><i class="bi bi-folder-fill"></i>{{keyValues.name}}</p>
                                                        <p class="folder-type" *ngIf="keyValues.fileType != 'file'">{{keyValues.fileType}}</p>
                                                        <p class="folder-type" *ngIf="keyValues.fileType == 'file'">{{keyValues.fileTypeExtension}}</p>
                                                        <p class="folder-created-date">{{keyValues.createdDate | date: 'medium'}}</p>
                                                        <p class="folder-createdBy">{{keyValues.createdBy}}</p>
                                                    </div>
                                                </div>
                                            </div> -->
                                        </div>
                        
                        
                                        <div *ngIf="!isLoading" style="width: 100%;">
                                            <div class="folder-list" *ngFor="let list of clientDocsList;let j = index">
                                                <div class="list-block">
                                                    <div class="folder" *ngIf="list.fileType == 'Folder'" (contextmenu)="onRightClick($event,list)" (click)="getFolderHierarchyByParentFolderId(list)">
                                                        <p class="folder-label-name"><i class="{{list.icon}}"></i>{{list.name}}</p>
                                                        <p class="folder-type" *ngIf="list.fileType != 'File'">{{list.fileType}}</p>
                                                        <p class="folder-type" *ngIf="list.fileType == 'File'">{{list.fileTypeExtension}}</p>
                                                        <p class="folder-created-date">{{list.createdDate | date: 'medium'}}</p>
                                                        <p class="folder-createdBy">{{list.createdBy}}</p>
                                                    </div>

                                                    <!-- <div class="folder" (contextmenu)="onRightClick($event,list)" *ngIf="list.fileType == 'file' && list.fileTypeExtension == 'application/pdf'">
                                        
                                                        <p class="folder-label-name"><i class="bi bi-file-earmark-pdf"></i>{{list.name}}</p>
                                                        <p class="folder-type" *ngIf="list.fileType != 'file'">{{list.fileType}}</p>
                                                        <p class="folder-type" *ngIf="list.fileType == 'file'">pdf</p> 
                                                        <p class="folder-created-date">{{list.createdDate | date: 'medium'}}</p>
                                                        <p class="folder-createdBy">{{list.createdBy}}</p>

                                                    </div> -->

                                                    <!-- <div class="folder" (contextmenu)="onRightClick($event,list)" *ngIf="list.fileType == 'file' && list.fileTypeExtension == 'text/csv'">

                                                        <p class="folder-label-name"><i class="bi bi-filetype-csv"></i>{{list.name}}</p>
                                                        <p class="folder-type" *ngIf="list.fileType != 'file'">{{list.fileType}}</p>
                                                        <p class="folder-type" *ngIf="list.fileType == 'file'">csv</p> 
                                                        <p class="folder-created-date">{{list.createdDate | date: 'medium'}}</p>
                                                        <p class="folder-createdBy">{{list.createdBy}}</p>

                                                    </div> -->

                                                    <div class="folder" (contextmenu)="onRightClick($event,list)" *ngIf="list.fileType == 'File' && checkFileTypeExtension(list.fileTypeExtension)">
                                                        <!-- <i class="bi bi-filetype-pdf"></i>
                                                        <p>{{list.name}}</p> -->
                                                        <p class="folder-label-name"><i class="{{list.icon}}"></i>{{list.name}}</p>
                                                        <p class="folder-type" *ngIf="list.fileType != 'File'">{{list.fileType}}</p>
                                                        <p class="folder-type" *ngIf="list.fileType == 'File'">{{list.fileTypeExtension}}</p> 
                                                        <p class="folder-created-date">{{list.createdDate | date: 'medium'}}</p>
                                                        <p class="folder-createdBy">{{list.createdBy}}</p>

                                                    </div>

                                                    <div class="folder" data-toggle="modal" data-target="#fileDetailModal" (click)="fileOpen(list)" (contextmenu)="onRightClick($event,list)" *ngIf="list.fileType == 'File' && checkImageType(list.fileTypeExtension)">
                                                        

                                                        <!-- <p-image
                                                        src="{{list.value}}" 
                                                        alt="Image" 
                                                        width="25"
                                                        [preview]="true"></p-image> -->
                                                        <p class="folder-label-name">
                                                            <!-- <img class="client-docs-image" *ngIf="list.fileType == 'file' && checkImageType(list.fileTypeExtension)" src="{{list.value}}" alt=""> -->
                                                            <p-image
                                                                src="{{list.value}}" 
                                                                class="client-docs-image" 
                                                                alt="Image" 
                                                                >
                                                            </p-image>
                                                            {{list.name}}
                                                        </p>
                                                        <p class="folder-type" *ngIf="list.fileType != 'File'">{{list.fileType}}</p>
                                                        <p class="folder-type" *ngIf="list.fileType == 'File'">{{list.fileTypeExtension}}</p>
                                                        <p class="folder-created-date">{{list.createdDate | date: 'medium'}}</p>
                                                        <p class="folder-createdBy">{{list.createdBy}}</p>

                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                        <div class="loader" *ngIf="isLoading">
                                            <div class="spinner"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </p-splitter>
                </div>
            </div>
        </div>
    </div>
</div>




<div class="modal fade" id="createModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
            
            <div class="row">
                <div class="col-lg-12 col-md-12">
                    <div class="form-group create-folder">
                        <label>Enter File Name </label>
                        <input type="text" [(ngModel)]="folderName" placeholder="enter new folder" class="form-control">
                    </div>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-lg-12 col-md-12">
                    <div class="create-folder">
                        <label>Meta Data </label>
                    </div>
                </div>
            </div>
            <div class="meta-data-block">

                <div class="row">
                    <div class="col-lg-3 col-md-3">
                        <div class=" create-folder">
                            <label style="margin: 0;">Id </label>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4">
                        <div class=" create-folder">
                            <label style="margin: 0;">Name </label>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4">
                        <div class=" create-folder">
                            <label style="margin: 0;">Value </label>
                        </div>
                    </div>
                    <div class="col-lg-1 col-md-1">
                      
                    </div>
                </div>
                <div class="row" *ngFor="let list of metaData;let i = index;let first = first;let last = last;">
                    <div class="col-lg-3 col-md-3">
                        <div class="form-group create-folder">
                            <input type="text" [(ngModel)]="list.id" class="form-control">
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4">
                        <div class="form-group create-folder">
                            <input type="text" [(ngModel)]="list.name" class="form-control">
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4">
                        <div class="form-group create-folder">
                            <input type="text" [(ngModel)]="list.value" class="form-control">
                        </div>
                    </div>
                    <div class="col-lg-1 col-md-1">
                        <div class="add-remove-button" *ngIf="!last">
                            <i class="bi bi-dash-circle" (click)="removeMetaData(i)"></i>
                        </div>
                        <div class="add-remove-button" *ngIf="last">
                            <i (click)="removeMetaData(i)" *ngIf="i!=0" class="bi bi-dash-circle"></i>
                            <i class="bi bi-plus-circle" (click)="addMetaData()"></i>
                        </div>
                    </div>
                </div>
                
            </div>
       -->

            <div class="meta-data-block">
                <div class="row">
                    <div class="col-lg-12 col-md-12">
                        <div class=" create-folder">
                            <label style="margin: 0;">Tag </label>
                        </div>
                    </div>
                    
                    <div class="col-lg-1 col-md-1">
                      
                    </div>
                </div>

                <div class="row" *ngFor="let list of tagName;let i = index;let first = first;let last = last;">
                    <div class="col-lg-11 col-md-11 create-folder">
                        <div class="form-group">
                            <input type="text" [(ngModel)]="list.name" class="form-control">
                        </div>
                    </div>
                    <div class="col-lg-1 col-md-1">
                        <div class="add-remove-button" *ngIf="!last">
                            <!-- <button (click)="removeMetaData(i)">remove</button> -->
                            <i class="bi bi-dash-circle" (click)="removeTagName(i)"></i>
                        </div>
                        <div class="add-remove-button" *ngIf="last">
                            <!-- <button (click)="removeMetaData(i)" *ngIf="i!=0">remove</button> -->
                            <i (click)="removeTagName(i)" *ngIf="i!=0" class="bi bi-dash-circle"></i>
                            <i class="bi bi-plus-circle" (click)="addTagName()"></i>
                            <!-- <button (click)="addMetaData()">add</button> -->
                        </div>
                    </div>
                </div>
            </div>




          <!-- <div class="form-group">
            <label>Branch</label>
            <select name="" id="" [(ngModel)]="branchId" class="form-control">
                <option value="" disabled selected hidden>---select branch---</option>
                <option value="{{list.branchMasterId}}" *ngFor="let list of branchList">{{list.name}}</option>
            </select>
        </div> -->
        <div class="modal-footer">
          <button type="button" (click)="cancelMetaTags()" id="closeModalButton1" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" (click)="addDoc()" class="btn btn-primary">Create</button>
        </div>
      </div>
    </div>
  </div>
</div>





<div class="modal fade" id="createModalFile" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
            
            <!-- <div class="row">
                <div class="col-lg-12 col-md-12">
                    <div class="form-group create-folder">
                        <label>Enter File Name </label>
                        <input type="text" [(ngModel)]="folderName" placeholder="enter new folder" class="form-control">
                    </div>
                </div>
            </div> -->

            <div class="row">
                <div class="col-lg-12 col-md-12">
                    <div class="create-folder">
                        <label>Meta Data </label>
                    </div>
                </div>
            </div>
            <div class="meta-data-block">

                <div class="row">
                    <div class="col-lg-5 col-md-5">
                        <div class=" create-folder">
                            <label style="margin: 0;">Reference Id </label>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <div class=" create-folder">
                            <label style="margin: 0;">Name </label>
                        </div>
                    </div>
                    <!-- <div class="col-lg-4 col-md-4">
                        <div class=" create-folder">
                            <label style="margin: 0;">Value </label>
                        </div>
                    </div> -->
                    <div class="col-lg-1 col-md-1">
                      
                    </div>
                </div>
                <div class="row" *ngFor="let list of metaData;let i = index;let first = first;let last = last;">
                    <div class="col-lg-5 col-md-5">
                        <div class="form-group create-folder">
                            <input type="text" [(ngModel)]="list.id" class="form-control">
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <div class="form-group create-folder">
                            <input type="text" [(ngModel)]="list.name" class="form-control">
                        </div>
                    </div>
                    <!-- <div class="col-lg-4 col-md-4">
                        <div class="form-group create-folder">
                            <input type="text" [(ngModel)]="list.value" class="form-control">
                        </div>
                    </div> -->
                    <div class="col-lg-1 col-md-1">
                        <div class="add-remove-button" *ngIf="!last">
                            <!-- <button (click)="removeMetaData(i)">remove</button> -->
                            <i class="bi bi-dash-circle" (click)="removeMetaData(i)"></i>
                        </div>
                        <div class="add-remove-button" *ngIf="last">
                            <!-- <button (click)="removeMetaData(i)" *ngIf="i!=0">remove</button> -->
                            <i (click)="removeMetaData(i)" *ngIf="i!=0" class="bi bi-dash-circle"></i>
                            <i class="bi bi-plus-circle" (click)="addMetaData()"></i>
                            <!-- <button (click)="addMetaData()">add</button> -->
                        </div>
                    </div>
                </div>
                
            </div>

            <div class="meta-data-block">
                <div class="row">
                    <div class="col-lg-12 col-md-12">
                        <div class=" create-folder">
                            <label style="margin: 0;">Tag </label>
                        </div>
                    </div>
                    
                    <div class="col-lg-1 col-md-1">
                      
                    </div>
                </div>
    
                <div class="row" *ngFor="let list of tagName;let i = index;let first = first;let last = last;">
                    <div class="col-lg-11 col-md-11 create-folder">
                        <div class="form-group">
                            <input type="text" [(ngModel)]="list.name" class="form-control">
                        </div>
                    </div>
                    <div class="col-lg-1 col-md-1">
                        <div class="add-remove-button" *ngIf="!last">
                            <!-- <button (click)="removeMetaData(i)">remove</button> -->
                            <i class="bi bi-dash-circle" (click)="removeTagName(i)"></i>
                        </div>
                        <div class="add-remove-button" *ngIf="last">
                            <!-- <button (click)="removeMetaData(i)" *ngIf="i!=0">remove</button> -->
                            <i (click)="removeTagName(i)" *ngIf="i!=0" class="bi bi-dash-circle"></i>
                            <i class="bi bi-plus-circle" (click)="addTagName()"></i>
                            <!-- <button (click)="addMetaData()">add</button> -->
                        </div>
                    </div>
                </div>
            </div>

            
        <div class="modal-footer">
          <button type="button" (click)="cancelMetaTags()" id="closeModalButton1" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" (click)="addFileBtn()" class="btn btn-primary">Upload</button>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="createModal1" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
            
            <div class="form-group" *ngIf="structureType == 'company'">
                <label>Company</label>
                <select name="" id="" [(ngModel)]="folderName" class="form-control">
                    <option value="" disabled selected hidden>---select company---</option>
                    <option value="{{list.companyName}}" *ngFor="let list of companyData">{{list.companyName}}</option>
                </select>
            </div>
            <div class="form-group" *ngIf="structureType == 'location'">
                <label>Location</label>
                <select name="" id="" [(ngModel)]="folderName" class="form-control">
                    <option value="" disabled selected hidden>---select location---</option>
                    <option value="{{list.city}}" *ngFor="let list of locationData">{{list.city}}</option>

                </select>
            </div>
            <div class="form-group" *ngIf="structureType == 'department'">
                <label>Department</label>
                <select name="" id="" [(ngModel)]="folderName" class="form-control">
                    <option value="" disabled selected hidden>---select department---</option>
                    <option value="{{list.name}}" *ngFor="let list of industryData">{{list.name}}</option>

                </select>
            </div>
            <div class="modal-footer">
                <button type="button" id="closeModalButton11" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                <button type="button" (click)="addDoc()" class="btn btn-primary">Create</button>
            </div>
        </div>
    </div>
  </div>
</div>

<!-- <button (click)="deleteClientDocs()">delete</button> -->



<div class="context-menu" [ngStyle]="{'top.px': position.y, 'left.px': position.x}" *ngIf="visible">
    <ul>
        <li *ngIf="menuOptionsType == 'Folder'" (click)="onOptionSelected('folder')" data-toggle="modal" data-target="#createModal"><i class="bi bi-folder"></i> New Folder</li>
        <li *ngIf="menuOptionsType == 'Folder'" (click)="onOptionSelected('file')"><i class="bi bi-file-earmark-text"></i> Add File</li>
        <li *ngIf="copiedData.length != 0" (click)="onOptionSelected('paste')"><i class="bi bi-arrow-down-circle"></i> Paste</li>
        <li (click)="onOptionSelected('copy')"><i class="bi bi-clipboard"></i> Copy</li>
        <li *ngIf="moveData.length != 0" (click)="onOptionSelected('moveTo')"><i class="bi bi-arrows-move"></i> Move to folder</li>

        <li *ngIf="moveData.length == 0" (click)="onOptionSelected('move')"><i class="bi bi-arrows-move"></i> Move</li>
    
        <li (click)="onOptionSelected('delete')" data-toggle="modal" data-target="#deleteModal"><i class="bi bi-trash"></i> Delete</li>
        <li (click)="onOptionSelected('rename')" data-toggle="modal" data-target="#renameModal"><i class="bi bi-pencil"></i> Rename</li>
        <!-- <li *ngIf="menuOptionsType == 'file'" (click)="onOptionSelected('download')"><i class="bi bi-download"></i> Download</li> -->
        <li *ngIf="menuOptionsType == 'File'" (click)="viewFile()"><i class="bi bi-download"></i> View</li>
    </ul>
</div>



<div class="context-menu" [ngStyle]="{'top.px': openPosition.y, 'left.px': openPosition.x}" *ngIf="openSpaceVisible">
    <ul>
        <li (click)="onOptionSelected('folder')" data-toggle="modal" data-target="#createModal"><i class="bi bi-folder"></i> New Folder</li>
        <li (click)="onOptionSelected('file')"><i class="bi bi-file-earmark-text"></i> Add File</li>
        <li *ngIf="isCompany" (click)="onOptionSelected('New Company Folder')" data-toggle="modal" data-target="#createModal1"><i class="bi bi-building"></i> New Company Folder</li>
        <li *ngIf="isLocation" (click)="onOptionSelected('New Location Folder')" data-toggle="modal" data-target="#createModal1"><i class="bi bi-geo-alt"></i> New Location Folder</li>
        <li *ngIf="isDepartment" (click)="onOptionSelected('New Department Folder')" data-toggle="modal" data-target="#createModal1"><i class="bi bi-houses"></i> New Department Folder</li>
        <li *ngIf="copiedData.length != 0" (click)="onOptionSelected('paste')"><i class="bi bi-arrow-down-circle"></i> Paste</li>
        <li *ngIf="moveData.length != 0" (click)="onOptionSelected('move')"><i class="bi bi-arrows-move"></i> Move here</li>
    </ul>
</div>

<div class="context-menu" [ngStyle]="{'top.px': leftPosition.y, 'left.px': leftPosition.x}" *ngIf="leftMenuVisible">
    <ul>
        <li (click)="onOptionSelected('folder')" data-toggle="modal" data-target="#createModal"><i class="bi bi-folder"></i> New Folder</li>
        <li (click)="onOptionSelected('file')"><i class="bi bi-file-earmark-text"></i> Add File</li>
        <li *ngIf="copiedData.length != 0" (click)="onOptionSelected('paste')"><i class="bi bi-arrow-down-circle"></i> Paste</li>
        <li *ngIf="moveData.length != 0" (click)="onOptionSelected('move')"><i class="bi bi-arrows-move"></i> Move here</li>
    </ul>
</div>





<div class="modal fade" id="deleteModal" #content tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteModalLabel">Confirmation!!</h5>
            </div>
            <div class="modal-body">
                <p>are you sure? want to delete??</p>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton2" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" (click)="deleteSubfolder()">Delete</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="renameModal" #content tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
            <!-- <div class="modal-header">
                <h5 class="modal-title" id="deleteModalLabel">
                    <span data-dismiss="modal">
                        <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                        </svg>
                    </span>
                </h5>
            </div> -->
            <div class="modal-body">
                <input type="text" class="form-control rename" [(ngModel)]="fileOrFolderName">
                <div class="modal-footer">
                    <button type="button" id="closeModalButton3" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" (click)="clientDocRename()">Rename</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="uploading-list">
    <p-messages [(value)]="messages" [enableService]="false"></p-messages>
</div>

<div class="no-access" *ngIf="isShowAccess">
    <div class="access-message">
        <div>
            <p><i class="bi bi-x-octagon"></i> You don't have access to " {{folderOrFileName}} "</p>
        </div>
        <div class="buttons">
            <button class="request-access" (click)="accessPrivilegesRequest()">Request Access</button>
            <button class="close-button" (click)="closeAccessMessage()">Close</button>
        </div>
    </div>
</div>












<div class="modal fade" id="fileDetailModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">File Details
            <span data-dismiss="modal">
              <i class="bi bi-x-lg"></i>
            </span>
          </h5>
        </div>
        <div class="modal-body" style="padding: 0;">
            <div class="file-data-block" *ngFor="let list of fileData">
                <div class="file-data">
                    <div class="file-data-top">
                        <div class="file-image">
                            <img src="{{list.value}}" alt="">
                        </div>
                        <div class="file-details">
                            <h4 class="file-details-title">File Details</h4>
            
                            <div class="details">
                                <div class="list">
                                    <p>File Name</p>
                                    <p style="width: 2%;">:</p>
                                    <p>{{list.name}}</p>
                                </div>
                                <div class="list">
                                    <p>File Type</p>
                                    <p style="width: 2%;">:</p>
                                    <p>{{list.fileType}}</p>
                                </div>
                                <div class="list">
                                    <p>Created by</p>
                                    <p style="width: 2%;">:</p>
                                    <p>{{list.createdBy}}</p>
                                </div>
                                <div class="list">
                                    <p>File Created</p>
                                    <p style="width: 2%;">:</p>
                                    <p>{{list.createdDate | date}}</p>
                                </div>
                                <div class="list">
                                    <p>Latest Status</p>
                                    <p style="width: 2%;">:</p>
                                    <p>{{list.latestStatus.status}}</p>
                                </div>
                            </div>
            
                            
                        </div>
                    </div>

                    <div class="file-data-2">
                        <h4>Meta Data</h4>

                        <div class="meta-data-block-list">
                            <div class="meta-label">
                                <p style="width: 20%;">Id</p>
                                <p style="width: 40%;">Name</p>
                                <p style="width: 40%;">Value</p>
                            </div>
                            <div class="meta-data" *ngFor="let metaData of list.metaData">
                                <p style="width: 20%;">{{metaData.id}}</p>
                                <p style="width: 40%;">{{metaData.name}}</p>
                                <p style="width: 40%;">{{metaData.value}}</p>
                            </div>
                        </div>
    
                        <div class="tags-block">
                            <p>Tags</p>
                            <span *ngFor="let tagName of list.tagName">{{tagName}}</span>
                        </div>
                    </div>
            
                    
                    
                </div>
            </div>
  
    
     
        <!-- <div class="modal-footer">
          <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div> -->
      </div>
    </div>
    </div>
  </div>